const config = {
    id: 1,
    name: '图集',
    type: 1,
    module_code: 'image_set',
    icon: 'icon-tms-image_set',
    font_icon: '&#xe73e;',
    style_type: 1,
    link_type: 5,
    link_data: [{
        memo: '建议尺寸：750px*184px'
    }],
    property_data: {
        border_spacing_type: 1
    }
};

export default config;